import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useFlagValue } from 'hooks';
import { HighVolumeCheckboxRenderer } from 'pages/HighVolumeLandingPage/components/HighVolumeCheckboxRenderer';
import { CheckboxRenderer } from './CheckboxRenderer';
import { VENDORS_TABLE_FIELDS } from './constants';
import { HeaderCheckboxRenderer } from './HeaderCheckboxRenderer';
import { VendorsTableDataType } from './types';
import { vendorsTableColumns } from './vendorsTableColumns';

export const useVendorsTableColumnDefs = (): {
  autoGroupColumnDef: ColDef<VendorsTableDataType>;
  columnDefs: ColDef<VendorsTableDataType>[];
} => {
  const intl = useIntl();

  const landingPageFlag = useFlagValue('dmsAccountingLandingPage');

  const autoGroupColumnDef: ColDef<VendorsTableDataType> = {
    field: VENDORS_TABLE_FIELDS.vendorNo,
    headerComponent: HeaderCheckboxRenderer,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: {
      suppressCount: true,
      innerRenderer:
        landingPageFlag === true ? HighVolumeCheckboxRenderer : CheckboxRenderer
    },
    equals: () => false,
    sortable: true,
    enableCellChangeFlash: false,
    flex: 1,
    minWidth: 200,
    maxWidth: 350,
    tooltipField: VENDORS_TABLE_FIELDS.vendorNo
  };

  const columnDefs = vendorsTableColumns(intl);

  // REASON FOR DISABLING: We do not want cell renderers to re-render when column defs are updated.
  // To ensure they don't change, we need to wrap them in useMemo() and pass an empty dependency array.
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  return useMemo(() => ({ autoGroupColumnDef, columnDefs }), []);
};
